import request from "@/utils/request";

// 获取列表
export function queryCheckList(data) {
  return request({
    url: "/check/selectPageV164",
    method: "get",
    params:data,
  });
}
// 获取调账列表
export function queryCheckListNew(data) {
  return request({
    url: "/adjustment/page",
    method: "get",
    params:data,
  });
}

// 根据id获取盘点信息
export function queryCheckById(id) {
  return request({
    url: `/check/getCheckByIdV164/${id}`,
    method: "get",
  });
}
// 获取盘点调账详情
export function queryCheckByIdNew(id) {
  return request({
    url: `/adjustment/${id}`,
    method: "get",
  });
}
// 新增盘点
export function insertCheck(data) {
  return request({
    url: "/check/saveCheckV164",
    method: "post",
    data,
  });
}
// 新增盘点调账
export function insertCheckNew(data) {
  return request({
    url: "/adjustment/save",
    method: "post",
    data,
  });
}

// 编辑盘点
export function updateCheck(data) {
  return request({
    url: "/check/update",
    method: "post",
    data,
  });
}

// 删除盘点信息
// data: { ids: 逗号分隔的字符串数组 }
export function deleteCheckById(data) {
  return request({
    url: `/check/delete`,
    method: "post",
    data,
  });
}
// 删除调账列表
export function deleteCheckByIdNew(data) {
  return request({
    url: `/adjustment/delete/`+data,
    method: "delete",
  });
}

// 状态列表
export function queryStatus() {
  return request({
    url: "/check/statuslist",
    method: "get",
  });
}

// 更改盘点状态
export function finishCheckStatus(id) {
  return request({
    url: `/check/finish/${id}`,
    method: "get",
  });
}
